import type { App } from 'vue';
import { installFormKitPlugin } from './form-kit';
import { installVueKeycloakPlugin } from './keycloak';
import { installPiniaPlugin } from './pinia';
import { installPrimeVuePlugin } from './prime-vue';
import { installVueQueryPlugin } from './vue-query';
import { installVueRouterPlugin } from './vue-router';
import { installI18nPlugin } from './zod-i18n';
import { installCustomDirectives } from './custom-directives';
import { installSentryPlugin } from './sentry';

export const installPlugins = async (app: App) => {
  await installVueKeycloakPlugin(app);

  installCustomDirectives(app);
  installPiniaPlugin(app);
  installVueRouterPlugin(app);
  installFormKitPlugin(app);
  installPrimeVuePlugin(app);
  installVueQueryPlugin(app);
  installI18nPlugin(app);
  installSentryPlugin(app);
};
